import i18n, { translateBackend } from '@assets/i18n/config';
import { generateClientNameString } from '@utils/generateClientNameString';
import { formatMoneyValue } from '@utils/moneyFormatting';
import { getGoalName } from './goal';
import type { SubAccount } from './goalSubAccountTypes';

export const getSubAccountName = (
  subAccount?: Partial<SubAccount>,
  withClientName?: boolean,
  displayCustodianAccountNumber?: boolean,
): string => {
  const otherWithNoName =
    subAccount?.goal?.type === 'OTHER' && !subAccount?.goal?.name;

  if (subAccount?.name) return subAccount.name;
  let name = '';
  if (subAccount?.account?.user && withClientName)
    name = generateClientNameString(subAccount.account.user);
  if (subAccount?.goal && !otherWithNoName)
    name = `${name ? `${name} - ` : ''}${getGoalName(subAccount.goal)}`;
  if (subAccount?.account?.type)
    name = `${name ? `${name} - ` : ''}${i18n.t(`accountTypes:${subAccount.account?.type}`)}`;
  if (translateBackend(subAccount?.financialProduct?.translatedName))
    name = `${name ? `${name} - ` : ''}${translateBackend(subAccount?.financialProduct?.translatedName)}`;
  if (subAccount?.statistics?.marketValueCents)
    name = `${name ? `${name} ` : ''}${`(${formatMoneyValue(subAccount?.statistics?.marketValueCents)})`}`;
  if (
    displayCustodianAccountNumber &&
    subAccount?.account?.custodianAccountNumber
  )
    name = `${name ? `${name} - ` : ''}${subAccount.account.custodianAccountNumber}`;
  return name;
};
